import { type MaskTextFieldRendererProps } from './mask-text-field-renderer';

export function getMaskTextFieldRendererProps(
  props: MaskTextFieldRendererProps,
  defaultMaskOptions: { mask: string },
  additionalSlotProps?: Record<string, unknown>,
) {
  if (props.mode === 'input') {
    return {
      ...props,
      slotProps: {
        maskOptions: defaultMaskOptions,
        ...props.slotProps,
        ...additionalSlotProps,
      },
    };
  }
  return {
    ...props,
    slotProps: {
      ...props.slotProps,
      ...additionalSlotProps,
    },
  };
}
